import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '../stores/auth';

const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import('../views/Home.vue'),
        meta: { requiresAuth: false }
    },
    {
        path: '/accords',
        name: 'accords',
        component: () => import('../views/Accords.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/accords/:id',
        name: 'accords-details',
        component: () => import('../views/AccordsDetails.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/adhesion',
        name: 'adhesion',
        component: () => import('../views/Adhesion.vue'),
        meta: { requiresUnauth: true }
    },
    {
        path: '/blog',
        name: 'blog',
        component: () => import('../views/Blog.vue'),
        meta: { requiresAuth: false }
    },
    {
        path: '/blog/:id',
        name: 'blog-post',
        component: () => import('../views/BlogPost.vue'),
        meta: { requiresAuth: false }
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/Login.vue'),
        meta: { requiresUnauth: true }
    },
    {
        path: '/profile',
        name: 'profile',
        component: () => import('../views/ProfileSettings.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/profile/delete',
        name: 'profile-delete',
        component: () => import('../views/ProfileSettings.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/faq',
        name: 'faq',
        component: () => import('../views/Faq.vue'),
        meta: { requiresAuth: false }
    },
    {
        path: '/about',
        name: 'about',
        component: () => import('../views/About.vue'),
        meta: { requiresAuth: false }
    },
    {
        path: '/events',
        name: 'events',
        component: () => import('../views/Events.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/adhesion-unac',
        name: 'adhesionCta',
        component: () => import('../views/AdhesionCta.vue'),
        meta: { requiresAuth: false }
    },
    {
        path: '/mentions-legales',
        name: 'legal-notice',
        component: () => import('../pages/LegalNotice.vue'),
        meta: { requiresAuth: false }
    },
    {
        path: '/politique-de-confidentialite',
        name: 'privacy-policy',
        component: () => import('../pages/PrivacyPolicy.vue'),
        meta: { requiresAuth: false }
    },
    {
        path: '/reset-password',
        name: 'reset-password',
        component: () => import('../views/ResetPassword.vue'),
        meta: { requiresAuth: false }
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: () => import('../views/NotFound.vue')
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

router.afterEach((to, from) => {
    window.scrollTo(0, 0);
});


// Navigation Guard
router.beforeEach((to, from, next) => {
    const authStore = useAuthStore();
    
    if (to.meta.requiresAuth && !authStore.isAuthenticated) {
        next({ 
            name: 'home',
            query: { redirect: to.fullPath,requiredAuth: true }
        });
    } else if (to.meta.requiresUnauth && authStore.isAuthenticated) {
        next({ name: 'home' });
    } else {
        next();
    }
});

export default router; 